// extracted by mini-css-extract-plugin
export default {"logo":"changeClient_logo__n1sXQ"};